<template>
  <base-card dark>
    <v-img
      :src="require('@/assets/articles/Freek_03.jpg')"
      class="grey lighten-2"
      height="650"
      width="100%"
      position="left"
    >
      <v-row class="fill-height pa-3" align="top">
        <v-col cols="12" md="7" offset-md="5">
          <h1 class="display-3 font-weight-light">Zodat we hem niet vergeten</h1>

          <div class="subheading text-uppercase pl-2 mb-4">Belangstellend, Zorgzaam en Behulpzaam</div>

          <!-- <v-btn color="primary" depressed>Subscribe</v-btn> -->
        </v-col>
      </v-row>
    </v-img>
  </base-card>
</template>

<script>
export default {
  name: "HomeBanner"
};
</script>
